import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChalkboardUser,
  faKey,
  faScreenUsers,
  faServer,
} from '@fortawesome/pro-light-svg-icons';

export enum StateRequiredForDone {
  Organization,
  Team,
  Application,
  Published,
}

export interface GettingStartedInformation {
  icon: IconProp;
  title: string;
  description: string;
  stateRequiredForDone: StateRequiredForDone;
}

export const ReadGettingStartedInformation = async (): Promise<
  GettingStartedInformation[]
> => {
  return [
    {
      icon: faServer,
      title: 'Setup Your Organization',
      description: 'Get access to the sandbox environment.',
      stateRequiredForDone: StateRequiredForDone.Organization,
    },
    {
      icon: faScreenUsers,
      title: 'Create Teams',
      description: 'Invite your colleagues, and build collaboratively.',
      stateRequiredForDone: StateRequiredForDone.Team,
    },
    {
      icon: faKey,
      title: 'Register Your App.',
      description: 'Get API keys and start development.',
      stateRequiredForDone: StateRequiredForDone.Application,
    },
    {
      icon: faChalkboardUser,
      title: 'Submit Your App.',
      description: 'Submit and get approvals for publishing your app.',
      stateRequiredForDone: StateRequiredForDone.Published,
    },
  ];
};
